// Plano de Governo apresentado em 2024 (eleição 2025-2028)
// Fonte: documento oficial da candidatura

export const PLANO_GOVERNO = {
  lema: "Lauro do Lado Certo · Para Avançar Cada Vez Mais",
  periodo: "2025 — 2028",
  ano_proposta: "2024",
  introducao: `Transformar visões em realidade exige mais do que desejo; requer determinação e um amor incondicional pelo que se faz. Desde que assumimos a nossa candidatura, temos priorizado as escutas, os debates e o planejamento como peça-chave da nossa futura gestão.

A administração de Lauro de Freitas tem sido um exemplo de sucesso e eficiência e chegou a hora de reafirmarmos nosso compromisso de continuar essa trajetória, consolidando as conquistas alcançadas e indo além. Apesar dos desafios, temos a determinação, o entusiasmo e as ferramentas necessárias para seguir avançando.

Fotografar o presente mapeando o futuro nos mostra uma Lauro de Freitas cheia de oportunidades em várias frentes. Vamos consolidar avanços na Saúde, na Educação e em outros setores, sempre valorizando iniciativas que gerem emprego e renda — direcionando recursos para os bairros mais carentes e transformando nossa cidade de maneira justa e inclusiva, com os dois pés no futuro.`,
  conquistas_ja_articuladas: [
    "Construção de maternidade com Casa de Parto",
    "Posto de saúde na Capiarara",
    "Posto de saúde na Quingoma",
    "Construção do Centro de Cultura Afro",
    "Aquisição de 30 ônibus elétricos com ar-condicionado e Wi-Fi",
    "Pavimentação e urbanização com prioridade aos bairros periféricos",
  ],
  eixos: [
    {
      id: "desenvolvimento-social",
      nome: "Desenvolvimento Social",
      icon: "HeartHandshake",
      diagnostico: "Acreditamos em uma cidade onde todos tenham voz e oportunidades. Nossos projetos visam promover a equidade, combater a violência contra a mulher, garantir os direitos das pessoas com deficiência e valorizar a diversidade cultural — transformando Lauro de Freitas em um lugar mais justo e humano.",
      grupos: [
        {
          subtitulo: "Mulheres",
          itens: [
            "Capacitação e empreendedorismo para 50% mais mulheres",
            "Fortalecer a rede de proteção às mulheres vítimas de violência, com mais casas de apoio e atendimento psicológico",
            "Patrulha Especializada e plena operação do Batalhão de Proteção à Mulher (BPPM)",
            "Estimular a instalação de uma DEAM (Delegacia Especializada de Atendimento à Mulher)",
            "Ampliar o Programa de Dignidade Menstrual",
            "Estudar viabilidade da mulher como beneficiária principal no Minha Casa Minha Vida",
            "Projeto específico de autonomia financeira para vítimas de violência doméstica",
            "Programa Lauro 50+ — capacitação e reinvenção profissional para maiores de 50",
            "Geração de renda para mulheres quilombolas",
            "Fortalecer denúncia compulsória no ambiente escolar",
          ],
        },
        {
          subtitulo: "Idosos",
          itens: [
            "Ampliar acessibilidade e gratuidade, respeitando o Estatuto da Pessoa Idosa",
            "Combate à violência contra a pessoa idosa em parceria com o Governo da Bahia",
            "Programas de alfabetização adaptados para idosos",
            "Estudar Remédio em Casa para a população idosa",
            "Criar os NUTIS — Núcleos da Terceira Idade (centros de convivência)",
            "Formar profissionais especializados na atenção ao idoso",
          ],
        },
        {
          subtitulo: "Juventude",
          itens: [
            "Conselhos e fóruns municipais com espaços de participação para jovens",
            "Programas de estágio, primeiro emprego e qualificação profissional",
            "Ampliar Jovem Aprendiz no serviço público municipal",
            "Plano Municipal da Juventude com participação ativa",
            "Programa Líder Jovem do Bairro — formação de lideranças estudantis",
            "Inclusão de jovens 16-29 em situação de vulnerabilidade (parceria com Governo da Bahia, inspirado no CEEPTIC)",
          ],
        },
        {
          subtitulo: "LGBTQIA+",
          itens: [
            "Centro de referência para apoio e atendimento à comunidade LGBTQIA+",
            "Políticas públicas de emprego, renda e proteção social",
            "MOSAICO — selo da Diversidade Étnico-Racial e LGBT+ para empresas",
            "Festivais, exposições e mostras de cinema valorizando a cultura LGBTQIA+",
            "Capacitação contínua da rede de acolhimento",
          ],
        },
        {
          subtitulo: "Igualdade Racial",
          itens: [
            "Fortalecimento do Conselho Municipal de Igualdade Racial",
            "Campanhas e programas de conscientização",
            "Apoio às comunidades quilombolas e grupos culturais de matriz africana",
            "Consolidação do Programa de Atenção à Doença Falciforme",
            "Centro de Referência da Cultura Negra no Terminal Turístico de Portão (parceria MinC)",
            "Capacitação de servidores no combate ao racismo institucional",
            "Calendário robusto de manifestações culturais negras",
          ],
        },
        {
          subtitulo: "Pessoas com Deficiência",
          itens: [
            "Manutenção e ampliação das 22 salas de inclusão na rede de ensino",
            "Profissionais em Libras e Braille",
            "Adequação do município à legislação de acessibilidade",
            "Fiscalização da contratação mínima de PCD pelo empresariado",
            "Parcerias para implantação da APAE no município",
          ],
        },
      ],
    },
    {
      id: "qualidade-de-vida",
      nome: "Qualidade de Vida",
      icon: "Activity",
      diagnostico: "Promover ações e projetos que garantam uma vida mais longa, mais saudável e mais feliz para todos — em uma cidade que valoriza o bem-estar físico, mental e social de sua população.",
      grupos: [
        {
          subtitulo: "Saúde Pública",
          itens: [
            "Nova Maternidade Municipal com Casa de Parto (PAC, parceria federal)",
            "Construção de 2 novos postos de saúde",
            "Cobertura ampliada da atenção básica: consultas, exames e medicamentos",
            "Programas de saúde da mulher, infantil e do idoso reforçados",
            "Saúde mental da mulher: depressão pós-parto, violência doméstica, transtornos alimentares",
            "Fortalecer CAPS e apoio psicológico em escolas e unidades",
            "Telemedicina para consultas de rotina e doenças crônicas",
            "Farmácia Popular online com agendamento e entrega em domicílio",
            "NAPS móvel para atender pessoas com sofrimento mental nas comunidades",
            "App Lauro Saúde — agendamento, exames, lembretes e info de saúde",
            "Vigilância sanitária digital com análises preditivas",
            "Saúde integrativa: acupuntura, homeopatia, fitoterapia",
            "Farmácias Vivas — hortas comunitárias de plantas medicinais",
            "Saúde Mental nas Escolas — psicólogos e assistentes sociais",
            "Agricultura urbana e hortas comunitárias",
          ],
        },
        {
          subtitulo: "Cultura",
          itens: [
            "Revitalização da Igreja de Santo Amaro e do Centro da Cultura Afro-Brasileira",
            "Editais, festivais e eventos comunitários",
            "Centros culturais e bibliotecas em bairros periféricos",
            "Cultura no currículo escolar",
            "Fortalecimento das festas populares como patrimônio cultural",
            "Novo modelo de gestão para teatros e espaços culturais",
            "Programas de residência artística (estudo de viabilidade)",
            "Fortalecimento do Projeto Neojibá (parceria com Governo da Bahia)",
          ],
        },
        {
          subtitulo: "Esporte e Lazer",
          itens: [
            "Raio-X do esporte e suas reais necessidades",
            "Construir e revitalizar espaços esportivos com grama sintética",
            "Articulação esporte ↔ educação, direitos humanos e saúde",
            "Sistema de bolsas para atletas e técnicos de alto rendimento",
          ],
        },
        {
          subtitulo: "Habitação",
          itens: [
            "Manter parceria federal para ampliar as 10 mil unidades do Minha Casa Minha Vida",
            "Captação de recursos federais, estaduais e privados",
            "Habitação Social como pauta elementar da política urbana",
            "Modernizar o setor de Habitação da Prefeitura",
            "Plano Habitacional de Interesse Social com regularização fundiária",
            "Programa Meu Lar — melhorias habitacionais",
          ],
        },
        {
          subtitulo: "Segurança Pública",
          itens: [
            "Fortalecer a Guarda Municipal (GCM) e policiamento comunitário",
            "Câmeras de monitoramento e iluminação pública",
            "Integração GCM com órgãos municipais e estaduais",
            "Bases da GCM em pontos estratégicos",
            "Ampliação do videomonitoramento integrado",
            "Departamento de segurança urbana e inteligência institucional",
            "Operação conjunta contra receptação de furtados e roubados",
            "Conselho Municipal de Segurança",
            "Casa de Justiça e Cidadania (convênio TJ-BA)",
            "Conselho Municipal de Atenção e Prevenção às Drogas",
            "Diálogo com Governo Estadual sobre expansão policial e de delegacias",
          ],
        },
      ],
    },
    {
      id: "conhecimento",
      nome: "Conhecimento",
      icon: "GraduationCap",
      diagnostico: "A educação é elemento transformador fundamental para uma sociedade mais igualitária e justa. Continuaremos investindo na educação pública, gratuita e de qualidade — com foco em inclusão digital e educação integral.",
      grupos: [
        {
          subtitulo: "Educação Integral",
          itens: [
            "Investimentos estratégicos nas escolas com maiores desafios de aprendizagem",
            "Jornada escolar expandida com esporte, cultura e tecnologia",
            "Formação continuada e valorização dos professores",
            "Inclusão digital: internet de qualidade e equipamentos para alunos e professores",
            "Recursos para educação inclusiva com atendimento especializado",
            "Centro de referência para alunos com TEA na rede municipal",
            "Estudo de viabilidade do Centro de Línguas Estrangeiras",
            "Ações integradas contra a evasão escolar",
            "Adaptação das escolas: rampas, banheiros acessíveis, materiais em braile, audiodescrição e LIBRAS",
          ],
        },
      ],
    },
    {
      id: "meio-ambiente",
      nome: "Meio Ambiente",
      icon: "Leaf",
      diagnostico: "Construir um futuro mais sustentável, onde a natureza e as pessoas convivam em harmonia. O Plano Municipal de Saneamento Básico foi uma iniciativa concreta para enfrentar os desafios do clima e garantir acesso à água potável.",
      grupos: [
        {
          subtitulo: "Sustentabilidade",
          itens: [
            "Coleta seletiva nas residências e comércios",
            "Novas cooperativas de catadores e mais ecopontos",
            "Logística reversa regulamentada",
            "Parcerias público-privadas para reciclagem, compostagem e energia",
            "Plano de arborização com participação da comunidade",
            "Qualificação de parques e praças",
            "Pet Parks — espaços para cães",
            "Plano municipal de adaptação climática",
            "Criação do Parque Ecológico de Ipitanga",
            "Recuperação sustentável das margens de rios e córregos",
            "Parcerias com condomínios para monitoramento de flora e fauna",
            "Revitalização dos rios Sapato, Ipitanga e Joanes",
            "Reforma da Orla com diretrizes globais de sustentabilidade",
          ],
        },
      ],
    },
    {
      id: "desenvolvimento-economico",
      nome: "Desenvolvimento Econômico",
      icon: "TrendingUp",
      diagnostico: "Lauro de Freitas, com sua localização estratégica e crescente dinamismo, possui potencial imenso para se tornar polo de desenvolvimento na Bahia em Turismo, Tecnologia, Logística e Serviços.",
      grupos: [
        {
          subtitulo: "Empreendedorismo e Inovação",
          itens: [
            "Linhas de crédito, capacitação e desburocratização para micro e pequenas empresas",
            "Redes organizadas de empreendimentos",
            "Melhorias na lei municipal de incentivos",
            "Arranjos produtivos inovadores nos bairros",
            "Qualificação para novas ocupações profissionais",
            "Distritos Inovadores em parceria com o Governo da Bahia",
            "Banco de Oportunidades — programas de iniciação ao trabalho",
            "Zonas especiais com incentivos fiscais em áreas vulneráveis",
            "Inclusão produtiva de jovens e mulheres",
            "Formalização de trabalhadores informais",
            "Cursos em IA, IoT e robótica",
            "Programa Lauro Empreende — isenções fiscais com planejamento de longo prazo",
            "InovaLauro — espaços flexíveis para autônomos, startups e empresas criativas",
          ],
        },
        {
          subtitulo: "Turismo",
          itens: [
            "Polo turístico com eventos corporativos, roteiros culturais e gastronômicos",
            "Cluster de inovação turística inspirado em municípios bem-sucedidos",
            "Apoio técnico para micro e pequenas empresas do turismo",
            "Requalificação da Orla e do Terminal Turístico de Portão",
            "Captação de R$ 2 milhões para dinamização do turismo",
            "Turismo de Base Comunitária Sustentável + cicloturismo",
            "Sinalização, hospedagem e guias turísticos profissionalizados",
            "Place branding e portal turístico de Lauro de Freitas",
          ],
        },
      ],
    },
    {
      id: "desenvolvimento-urbano",
      nome: "Desenvolvimento Urbano",
      icon: "Building2",
      diagnostico: "Um dos principais municípios da Região Metropolitana de Salvador, Lauro de Freitas necessita de planejamento urbano eficiente e inovador para crescimento sustentável — impulsionando qualidade de vida, atraindo investimentos e preservando o meio ambiente.",
      grupos: [
        {
          subtitulo: "Mobilidade e Infraestrutura",
          itens: [
            "Duplicação da Avenida Gerino de Souza Filho (Estrada do Trabalhador)",
            "Programa de monitoramento tecnológico para manutenção asfáltica",
            "Pavimentação de novas ruas e construção de ciclovias",
            "Ampliação da macrodrenagem para canais ainda não contemplados",
            "Nova modelagem de zeladoria urbana com manutenção constante",
            "Soluções técnicas para mobilidade de PCDs",
            "30 ônibus elétricos com Wi-Fi e ar-condicionado",
            "Mobilidade sustentável: bicicletas e deslocamento a pé",
            "Obras estruturantes em vias principais",
          ],
        },
        {
          subtitulo: "Planejamento e Ordenamento",
          itens: [
            "Plano diretor participativo monitorado e atualizado",
            "Participação da comunidade nas decisões sobre uso do solo",
            "Regularização fundiária com segurança jurídica",
            "Conclusão de vias incompletas com duplicação e prolongamento",
            "Modernização ágil da aprovação de empreendimentos",
            "Mapa de risco de acidentes naturais com ampla divulgação",
            "Zona Azul Digital (estudo de viabilidade)",
            "Reorganização de pelo menos 3 áreas do comércio ambulante",
            "Mercado Central de Lauro de Freitas (estudo)",
            "Calçadão do Centro com cobertura em toda a rua",
          ],
        },
      ],
    },
    {
      id: "gestao-eficiente",
      nome: "Gestão Eficiente",
      icon: "Settings2",
      diagnostico: "Com seu rápido crescimento, Lauro de Freitas demanda gestão pública eficiente e inovadora — fundamental para garantir bem-estar, desenvolvimento sustentável e atração de investimentos.",
      grupos: [
        {
          subtitulo: "Modernização e Transparência",
          itens: [
            "Prestação de contas e participação cidadã",
            "Capacitação dos servidores públicos",
            "Reformulação do planejamento estratégico da Prefeitura",
            "Responsabilidade fiscal com execução orçamentária transparente",
            "Conselhos municipais e ouvidorias fortalecidos",
            "Consórcios com municípios vizinhos",
            "Reformulação das Administrações Regionais com novas tecnologias",
            "Tecnologias para ampliar a participação comunitária em políticas públicas",
            "Inova Lauro — Agência Municipal de Inovação e Sustentabilidade",
            "Auditorias regulares e controle social",
            "Procuradoria Municipal fortalecida",
            "Unidade de Entrega no Gabinete do Prefeito (escritório de prioridades)",
            "Superintendência de Prevenção e Combate a Álcool e Drogas",
          ],
        },
      ],
    },
  ],
};
